import {
    Component,
    Input,
    OnInit,
    SimpleChanges, effect} from '@angular/core';
import { IdentifierService } from 'merlin-core';
import { UserProfileObject, UserService } from 'merlin-library';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { FRANCE_COUNTRY_CODE } from 'projects/clinician/src/app/constants/france.constants';
import { USA_COUNTRY_CODE } from 'projects/clinician/src/app/constants/USA.constants';
import { V } from '@angular/cdk/scrolling-module.d-ud2XrbF8';

@Component({
    selector: 'view-patient-details',
    templateUrl: './view-patient-details.component.html',
    styleUrls: ['./view-patient-details.component.scss'],
    standalone: false,
})
export class ViewPatientDetailsComponent implements OnInit {

    isJapanseLocale: boolean = false;
    isUSAClinic: boolean;
    isCountryFrance: boolean;
    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() userProfile;

    public stringLabels = [
        "label.gb.patientdetailsbr",
        "label.gb.alternatefirstname",
        "label.gb.alternatelastname",
        "label.gb.firstname",
        "label.gb.middlename",
        "label.gb.lastname",
        "label.gb.date_of_birth",
        "label.gb.pat_record_no",
        "label.gb.Merlin.net_number",
        "label.gb.clinic_loc",
        "label.gb.merlin_net_enrollment",
        "label.gb.race",
        "label.gb.gender",
        "label.gb.pat_prefers",
        "label.gb.INSnumber_long",
        "label.gb.firstname_long",
        "label.gb.givennames_long",
        "label.gb.lastname_long",
        "label.gb.SSN",
        "label.gb.date_of_birth_long",
        "label.gb.pat_record_no",
        "label.gb.clinic_loc",
        "label.gb.merlin_net_enrollment",
        "label.gb.OID",
        "label.gb.gender_long",
        "label.gb.birth_code_long",
        "label.gb.pat_prefers",
        "label.gb.lastname_used_long",
        "label.gb.firstname_used_long",
    ]

    public labels: Record<string, string>;
    public toolTipHtmlLabel;

    constructor(
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private userService: UserService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnInit() {
        this.translateStrings();
        this.toolTipHtmlLabel = this.translateTooltip();
        this.userService
            .getUserProfile(false)
            .subscribe((res: UserProfileObject) => {
                this.isCountryFrance =
                    res.clinicCountryCd === FRANCE_COUNTRY_CODE;
                this.isUSAClinic = res.clinicCountryCd === USA_COUNTRY_CODE;
                this.isJapanseLocale =
                    res.locale == 'ja_JP_USA' ||
                        res.locale == 'ja_JP_TUV' ||
                        res.locale == 'ja_JP_ANZ' ||
                        res.locale == 'ja_JP_JAP'
                        ? true
                        : false;
            });
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    translateTooltip(){
        return this.localizationService.generateLocalizedStr('label.gb.pat_det_tooltip', null, 'html');
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    getClinicLocation() {
        let patDevice = this.patRes.dropdowns?.locations.filter((dev) => {
            return dev.value == this.patRes.patient?.locationId;
        });
        if (typeof patDevice === 'undefined' || patDevice?.length == 0) {
            return '';
        } else {
            return patDevice[0]?.label;
        }
    }

    getRace() {
        let patRace = this.patRes.dropdowns?.raceCodes.filter((code) => {
            return code.codeId == this.patRes.patient?.raceCd;
        });
        if (!patRace) {
            return '';
        } else {
            const raceText = this.formatDDString(patRace[0]);
            return this.translate(raceText);
        }
    }

    getGender() {
        let patChamb = this.patRes.dropdowns?.genderCodes
            .filter((code) => {
                return code.codeId == this.patRes.patient?.genderCd;
            });
        if (!patChamb) {
            return '';
        } else {
            const genderText = this.formatDDString(patChamb[0]);
            return this.translate(genderText);
        }
    }

    getLang() {
        let patChamb = this.patRes.dropdowns?.langCodes.filter((code) => {
            return code.codeId == this.patRes.patient.languageCd;
        });
        if (!patChamb) {
            return '';
        } else {
            const langText = this.formatDDString(patChamb[0]);
            return this.translate(langText);
        }
    }

    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }

    formatDDString(ddObj: any) {
        if (ddObj) {
            return this.localizationService.generateLocalizedStr(
                'data.Code.' + ddObj.qualifier + '.Code_Desc.' + ddObj.code
            );
        } else {
            return '';
        }
    }
}
